import SettingsModal from './components/SettingsModal';
import SettingsClient from './SettingsClient';

import locales from './constants/locales';
import { languageCodes } from './constants/languages';
import timeZones from './constants/timeZones';

export { SettingsClient, locales, languageCodes, timeZones };
export default SettingsModal;
